import { Div, H2,H3,P,Ul} from "./style"
import Card from "../../Components/Card"
import Aside from "../../Components/Aside"
import { Main } from "../Home/style"
import certificado from "../../Assets/certificadoFront.jpg"
import { useEffect, useState } from "react"
import { Loading } from "../../Components/Projects/style"
import Menu from "../../Components/Menu"

const About = () =>{
    const [isLoading, setIsLoading] = useState(true)

    useEffect(()=>{
        setTimeout(()=> setIsLoading(false), 1500)
    },[])

    return(
        <>
        <Aside/>
        <Main>
            <Card path={'/'} button={'Projetos'}/>
            <Menu/>
            <Div>
            {
                isLoading ? 
                <Loading/>
                :
                <>
                    <H2>Sobre mim</H2>
                    <P>
                        Sou um Dev Front-end em busca de atingir meus objetivo e entrar no mercado de desenvolvimento,
                        utilizando das melhores tecnologias para suprir necessidades e resolver problemas.
                        Tenho conhecimento em programação para web com HTML, CSS, JavaScript e ReactJs, sou aluno da Kenzie Academy Brasil,
                        onde desenvolvi diversos projetos, sempre utilizando das melhores e mais atuais ferramentas de desenvolvimento assim como
                        utilizando sempre das melhores práticas possiveis, buscando adquirir cada vez mais conhecimento e expêriencia para melhorar
                        como desenvolver web. 
                    </P>

                    <H3>Tecnologias</H3>
                    <Ul>
                        <li>HTML</li>
                        <li>ReactJs</li>
                        <li>CSS</li>
                        <li>JavaScript</li>
                        <li>GIT</li>
                        <li>GitHub</li>
                        <li>Vercel</li>
                        <li>Redux</li>
                        <li>ContextApi</li>
                        <li>PostgreSQL</li>   
                        <li>Docker</li>
                        <li>Typescript</li>
                        <li>Express</li>
                    </Ul>

                    <H3>Certificados</H3>
                    <img src={certificado} alt="certificado-font-end"/>
                </>
                }
            </Div>
        </Main>
        </>
    )
}

export default About